module.exports = __webpack_public_path__ + "static/media/fac14.ac554423.jpg";